"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    File.prototype.arrayBuffer = File.prototype.arrayBuffer || myArrayBuffer;
    Blob.prototype.arrayBuffer = Blob.prototype.arrayBuffer || myArrayBuffer;
    function myArrayBuffer() {
        var _this = this;
        // this: File or Blob
        return new Promise(function (resolve) {
            var fr = new FileReader();
            fr.onload = function () {
                resolve(fr.result);
            };
            fr.readAsArrayBuffer(_this);
        });
    }
}
exports.default = default_1;
//# sourceMappingURL=blob.js.map